import { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
    Link
} from "react-router-dom";

export default function Index(props) {
    
	useEffect(() => {
        document.querySelectorAll('.nav-item a').forEach((el, i) => {
            //if (i != 0) {
                if (el.getAttribute('href').split('?')[0] == window.location.pathname) {
                    el.parentNode.querySelector('a').style.backgroundColor = "#585858";
                }
            //}
        });
		
        document.querySelectorAll('.nav-item a').forEach((el, i) => {
            el.addEventListener('click', (e) => {
				toast.dismiss();
                document.querySelectorAll('.nav-item a').forEach((el, i) => {
                    el.style.backgroundColor = "#212529";
                });				
                el.parentNode.querySelector('a').style.backgroundColor = "#585858";
            });
        });	
    }, []);		

    return (
        <ul class="mynav nav nav-pills flex-column mb-auto p-0">
            <li class="nav-item mb-1">
                <Link to="/ShowReviewDetail?page=نمایش گزارش بازدید">
                    <i class="fa fa-industry text-warning"></i>
                    نمایش گزارش بازدید
                </Link>
            </li>
			
            <li class="nav-item mb-1">
                <Link to="/SubmitRequest?page=ثبت درخواست">
                    <i class="fa fa-plus-square  text-warning"></i>
                    ثبت درخواست
                </Link>
            </li>

            <li class="nav-item mb-1">
                <Link to="/RequestsReview?page=مشاهده درخواست">
                    <i class="fa fa-file-text text-warning"></i>
                    مشاهده درخواست
                </Link>
            </li>
            <li class="nav-item mb-1">
                <Link to="/ShowModernizationToll?page=مشاهده عوارض نوسازی">
                    <i class="fa fa-list-alt text-warning"></i>
                    مشاهده عوارض نوسازی
                </Link>
            </li>
            <li class="nav-item mb-1">
                <Link to="/CityFishView?page=فیش های شهرسازی">
                    <i class="fa fa-outdent text-warning"></i>
                    فیش های شهرسازی
                </Link>
            </li>
            <li class="nav-item mb-1">
                <Link to="/OrdersMapView?page=مشاهده دستور نقشه">
                    <i class="fa fa-columns text-warning"></i>
                    مشاهده دستور نقشه
                </Link>
            </li>

            {/*<li class="nav-item mb-1">
                <Link to="/TaxReview?page=پیش نویس عوارض">
                    <i class="fa fa-paste text-warning"></i>
                    پیش نویس عوارض
                </Link>
            </li>*/}

            <li class="nav-item mb-1">
                <Link to="/LettersView?page=مشاهده نامه ها">
                    <i class="fa fa-envelope-open text-warning"></i>
                    مشاهده نامه ها
                </Link>
            </li>

            <li class="nav-item mb-1">
                <Link to="/ConstView?page=مشاهده پروانه">
                    <i class="fa fa-id-card text-warning"></i>
                    مشاهده پروانه
                </Link>
            </li>

            <li class="nav-item mb-1">
                <Link to="/CertificateView?page=مشاهده گواهی">
                    <i class="fa fa-recycle text-warning"></i>
                    مشاهده گواهی
                </Link>
            </li>

            <li class="nav-item mb-1">
                <Link to="/Committee100Tax?page=مشاهده ابلاغیه کمیسیون">
                    <i class="fa fa-podcast text-warning"></i>
                    مشاهده ابلاغیه کمیسیون
                </Link>
            </li>
        </ul>
    );
}
